import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons/faArrowLeft';
import { faCreditCard } from '@fortawesome/pro-solid-svg-icons/faCreditCard';
import { faMessages } from '@fortawesome/pro-solid-svg-icons/faMessages';
import {
	Button,
	ColourStateOutline,
	ColourStateSolid,
	DropdownMenu,
	DropdownMenuEntry,
	FlexAlign,
	FlexGap,
	FlexJustify,
	PageHeaderNarrow,
	StackHorizontal,
	useLayout,
	useTranslation,
} from '@ukpostbox/frontend-framework';
import React from 'react';
import { useNavigate } from 'react-router';
import { faCog } from '@fortawesome/pro-solid-svg-icons/faCog';
import { useMailbox } from '../../../Mailboxes/Providers/NewMailboxProvider';
import { useSite } from '../../../_Global/Providers/SiteInterfaceProvider';
import { MailItemMetaPills } from './MailItemMetaPills';
import { useMailboxesStore } from '../../../Mailboxes/Providers/Stores/MailboxesStore';

function MailItemHeader() {
	const navigate = useNavigate();
	const { t } = useTranslation();
	const { isTiny, isSmall, isMedium } = useLayout();
	const { UpdateSiteContact } = useSite();

	const { mailItemData } = useMailbox();

	const mailItemOnHold = useMailboxesStore((state) => state.mailItemOnHold);
	const mailItemRequiresTopUp = useMailboxesStore((state) => state.mailItemRequiresTopUp);

	return (
		<PageHeaderNarrow
			title={mailItemData?.trackingId as string}
			preTitleAddon={
				<Button title={t('actions.goBack')} onClick={() => navigate(-1)} iconOnly icon={faArrowLeft} />
			}
			descriptionContent={!isTiny && !isSmall && !isMedium ? <MailItemMetaPills /> : undefined}
			extraClass={`mail-item-page-header ${mailItemOnHold || mailItemRequiresTopUp ? 'mail-item-issue from-left show-issues' : ''}`}
			secondaryHeader
		>
			<StackHorizontal gap={FlexGap.Small} align={FlexAlign.Center} justify={FlexJustify.Between}>
				{(isTiny || isSmall || isMedium) && (
					<DropdownMenu
						title={t('mailboxes.mailActions.title')}
						trigger={
							<Button
								title={t('mailboxes.mailActions.title')}
								showArrow
								squared
								icon={faCog}
								iconOnly
								extraClass='mail-item-menu ml-a'
							/>
						}
					>
						{!mailItemOnHold && !mailItemRequiresTopUp && (
							<>
								{/*                                <MailboxesSelectedMenu
                                    showCustomFolderRemove={!!mailBoxInfo.customFolderId && mailBoxInfo.customFolderId > -1}
                                /> */}
								<DropdownMenuEntry title={t('labels.divider')} sectionDivider />
							</>
						)}
						<DropdownMenuEntry
							title={t('actions.messageUs')}
							onClick={() =>
								UpdateSiteContact(
									true,
									2,
									undefined,
									`With regards to mail item: ${mailItemData?.trackingId}`,
								)
							}
							icon={faMessages}
						/>
					</DropdownMenu>
				)}

				{mailItemRequiresTopUp && (
					<div className='ml-a'>
						<Button
							title={t('actions.topUp')}
							onClick={() => navigate('/manage-account/payment/top-up')}
							squared
							icon={faCreditCard}
							colour={ColourStateSolid.Warning}
						/>
					</div>
				)}

				{!isTiny && !isSmall && !isMedium && !mailItemRequiresTopUp && (
					<div className='ml-a'>
						<Button
							title={t('actions.messageUs')}
							onClick={() =>
								UpdateSiteContact(
									true,
									2,
									undefined,
									`With regards to mail item: ${mailItemData?.trackingId}`,
								)
							}
							squared
							icon={faMessages}
							colour={mailItemData?.holdReason ? ColourStateSolid.Warning : ColourStateOutline.Secondary}
						/>
					</div>
				)}
			</StackHorizontal>
		</PageHeaderNarrow>
	);
}

export { MailItemHeader };
